module.exports = __webpack_public_path__ + "res/28-img_reward_b.7604c38335e3d78c58181ce8d61ce171.png";